module.exports = __webpack_public_path__ + "img/product_11.740fdb5.jpg";